import { enableProdMode } from '@angular/core';
import { config } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@environments/environment';
import { init, startSpan } from '@sentry/angular';
import { SENTRY_CONF } from '@siko-spartacus/configurations';
import { bootstrapApplication } from '@angular/platform-browser';
import { SikoUtils } from '@siko/shared/utils/siko-utils';


if (environment.production) {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    startSpan({ name: 'Angular Bootstrap', op: 'ui.angular.bootstrap' }, async () => {
        try {
            await bootstrapApplication(AppComponent, config);
        } catch (err) {
            console.error(err);
        }
    });
});

// Initialize Sentry
const sentryConfig = SikoUtils.getSentryConfig();
if (sentryConfig && sentryConfig.enabled) {
    init({
        ...SENTRY_CONF,
        ...sentryConfig.options
    });
} else {
    console.warn('Sentry is disabled!')
}
